import React from "react";
import handprint from "./handprint.png";
import emf from "./emf.png";
import freezing from "./freezing.png";
import orb from "./orb.png";
import writing from "./writing.png";
import box from "./box.png";
import dots from "./dots.png";
import styled from "styled-components";
export function EvidenceIcon({ evidence, className }) {
  const getIcon = () => {
    if (evidence === "Ghost Writing") {
      return <Icon src={writing} alt={evidence} />;
    }
    if (evidence === "Freezing Temperatures") {
      return <Icon src={freezing} alt={evidence} />;
    }
    if (evidence === "EMF Level 5") {
      return <Icon src={emf} alt={evidence} />;
    }
    if (evidence === "Ghost Orbs") {
      return <Icon src={orb} alt={evidence} />;
    }
    if (evidence === "Spirit Box") {
      return <Icon src={box} alt={evidence} />;
    }
    if (evidence === "Fingerprints") {
      return <Icon src={handprint} alt={evidence} />;
    }
    if (evidence === "D.O.T.S Projector") {
      return <Icon src={dots} alt={evidence} />;
    }
    throw new Error("unknown evidence type");
  };
  const icon = getIcon();
  return <div className={className}>{icon}</div>;
}
const Icon = styled.img`
  @media (max-width: 750px) {
    width: 35px;
    height: 35px;
  }
`;
